import Link from "next/link";
import { Guest } from "../types";
import React from "react";

interface GuestNamesLinksProps {
  guests: Guest[];
}

export const GuestNamesLinks: React.FC<GuestNamesLinksProps> = ({ guests }) => {
  if (guests.length === 0) return null;
  if (guests.length === 1) return <Link href={`/guests/${guests[0].slug}`} className="hover:underline">{guests[0].name}</Link>;
  if (guests.length === 2) return <><Link href={`/guests/${guests[0].slug}`} className="hover:underline">{guests[0].name}</Link> and <Link href={`/guests/${guests[1].slug}`} className="hover:underline">{guests[1].name}</Link></>;
  const lastGuest = guests[guests.length - 1];
  const otherGuests = guests.slice(0, -1);
  return <>{otherGuests.map((g, i) => <span key={g.slug}><Link href={`/guests/${g.slug}`} className="hover:underline">{g.name}</Link>{i < otherGuests.length - 1 ? ", " : ""}</span>)} and <Link href={`/guests/${lastGuest.slug}`} className="hover:underline">{lastGuest.name}</Link></>;
};
